/**
 * useKanbanSocket — Socket.IO para Kanban (0258)
 * Escucha ticket, tag y kanban:updated (citas reprogramadas/confirmadas).
 */
import { useEffect, useContext } from "react";
import { SocketContext } from "../../../context/Socket/SocketContext";
import logger from "../../../utils/logger";

export default function useKanbanSocket({ isInitialized, user, setTags, setTickets, refetch }) {
  const socketManager = useContext(SocketContext);

  useEffect(() => {
    if (!isInitialized || !user) return;

    const companyId = localStorage.getItem("companyId");
    const socket = socketManager.getSocket(companyId);

    if (!socket) {
      logger.dashboard.warn("Socket no disponible para Kanban");
      return;
    }

    const handleTicketUpdate = (data) => {
      if (data.action === "update" && data.ticket) {
        setTickets((prev) => {
          const idx = prev.findIndex((t) => t.id === data.ticket.id);
          const next = [...prev];
          if (idx >= 0) next[idx] = { ...next[idx], ...data.ticket };
          else next.push(data.ticket);
          return next;
        });
      }
      if (data.action === "delete") {
        setTickets((prev) => prev.filter((t) => t.id !== data.ticketId));
      }
    };

    const handleTagUpdate = (data) => {
      if (data.action === "update" && data.tag) {
        setTags((prev) => {
          const idx = prev.findIndex((t) => t.id === data.tag.id);
          const next = [...prev];
          if (idx >= 0) next[idx] = { ...next[idx], ...data.tag };
          else next.push(data.tag);
          return next;
        });
      }
      if (data.action === "delete") {
        setTags((prev) => prev.filter((t) => t.id !== data.tagId));
      }
    };

    const handleKanbanUpdated = () => {
      if (typeof refetch === "function") refetch();
    };

    socket.on(`company-${companyId}-ticket`, handleTicketUpdate);
    socket.on(`company-${companyId}-tag`, handleTagUpdate);
    socket.on("kanban:updated", handleKanbanUpdated);

    return () => {
      socket.off(`company-${companyId}-ticket`, handleTicketUpdate);
      socket.off(`company-${companyId}-tag`, handleTagUpdate);
      socket.off("kanban:updated", handleKanbanUpdated);
    };
  }, [isInitialized, user, socketManager, setTags, setTickets, refetch]);
}
